export const TypeQualification = ['Rncp', 'CodeDiplome'] as const

export type TypeQualification = (typeof TypeQualification)[number]

export const TypeQualificationLibelle: {
  [key in TypeQualification]: string
} = {
  Rncp: 'Code RNCP',
  CodeDiplome: 'Code Diplôme',
} as const

